const oneLbInKg = 2.20462;

export { oneLbInKg };
